import React from 'react';
import { ShieldCheck } from 'lucide-react';
import Reveal from './Reveal';
import { TRUST_BADGES } from '../data/mock';

const TrustBadges = () => {
  return (
    <section className="bg-white border-b">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8">
        <Reveal className="text-center mb-6">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#8a998f]">
            Certified, accredited &amp; trusted
          </p>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {TRUST_BADGES.map((b, i) => (
            <Reveal
              key={b.abbr}
              delay={i * 70}
              className="flex items-center gap-3 rounded-xl border border-[#eef2e8] bg-[#fafcf7] px-4 py-3 hover:border-brand transition-colors"
            >
              <div className="h-11 w-11 shrink-0 rounded-lg bg-[#eaf4dd] flex items-center justify-center">
                <ShieldCheck className="h-5 w-5 text-brand" />
              </div>
              <div className="min-w-0">
                <div className="font-display font-bold text-[#13251b] leading-tight">{b.abbr}</div>
                <div className="text-[11px] text-[#5b6a60] leading-tight truncate">{b.note}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
